import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loading: -1,
    creating: -1,
    updating: -1,
    updatingFee: -1,
    deleting: -1,
  },
  minimumFee: {},
  certFee: {},
  certTypes: [],
  certType: {},
  meta: {},
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error, typeId } = action;

  switch (type) {
    // update cert fee
    case ACTION_TYPES.CERT_FEE_UPDATED_REQUESTED:
      return {
        ...state,
        status: {
          updatingFee: 0,
        },
      };
    case ACTION_TYPES.CERT_FEE_UPDATED_SUCCEED:
      return {
        ...state,
        status: {
          updatingFee: 1,
        },
        certFee: { ...state.certFee, ...payload.data },
      };
    case ACTION_TYPES.CERT_FEE_UPDATED_FAILED:
      return {
        ...state,
        status: {
          updatingFee: 2,
        },
        error: {
          message: 'Cannot update fee successfully',
        },
      };
    // get cert fee
    case ACTION_TYPES.CERT_FEE_GOT_REQUESTED:
      return {
        ...state,
        status: {
          loading: 0,
        },
      };
    case ACTION_TYPES.CERT_FEE_GOT_SUCCEED:
      return {
        ...state,
        status: {
          loading: 1,
        },
        certFee: { ...state.certFee, ...payload.data },
      };
    case ACTION_TYPES.CERT_FEE_GOT_FAILED:
      return {
        ...state,
        status: {
          loading: 2,
        },
        error: 'Cannot get minimum fee successfully',
      };
    // get minimum fee
    case ACTION_TYPES.MINIMUM_FEE_GOT_REQUESTED:
      return {
        ...state,
        status: {
          loading: 0,
        },
      };
    case ACTION_TYPES.MINIMUM_FEE_GOT_SUCCEED:
      return {
        ...state,
        status: {
          loading: 1,
        },
        minimumFee: { ...state.minimumFee, ...payload.data },
      };
    case ACTION_TYPES.MINIMUM_FEE_GOT_FAILED:
      return {
        ...state,
        status: {
          loading: 2,
        },
        error: 'Cannot get minimum fee successfully',
      };
    // delete certType
    case ACTION_TYPES.CERTTYPE_DELETED_REQUESTED:
      return {
        ...state,
        status: {
          deleting: 0,
        },
      };
    case ACTION_TYPES.CERTTYPE_DELETED_SUCCEED:
      return {
        ...state,
        status: {
          deleting: 1,
        },
        certType: {},
        certTypes: [...state.certTypes.filter(certType => certType.id !== typeId)],
      };
    case ACTION_TYPES.CERTTYPE_DELETED_FAILED:
      return {
        ...state,
        status: {
          deleting: 2,
        },
        error: 'Cannot delete certType successfully',
      };
    // create certType
    case ACTION_TYPES.CERTTYPE_CREATED_REQUESTED:
      return {
        ...state,
        status: {
          creating: 0,
        },
      };
    case ACTION_TYPES.CERTTYPE_CREATED_SUCCEED:
      return {
        ...state,
        status: {
          creating: 1,
        },
        certType: { ...state.certType, ...payload.data },
        certTypes: [payload.data, ...state.certTypes],
        meta: payload.meta,
      };
    case ACTION_TYPES.CERTTYPE_CREATED_FAILED:
      return {
        ...state,
        status: {
          creating: 2,
        },
        error: {
          message: 'Cannot create certType successfully',
        },
      };
    // getListType
    case ACTION_TYPES.CERTTYPE_GOT_REQUESTED:
      return {
        ...state,
        status: {
          loading: 0,
        },
      };
    case ACTION_TYPES.CERTTYPE_GOT_SUCCEED:
      return {
        ...state,
        status: {
          loading: 1,
        },
        certTypes: [...payload.data],
        meta: payload.meta,
      };
    case ACTION_TYPES.CERTTYPE_GOT_FAILED:
      return {
        ...state,
        status: {
          loading: 2,
        },
        error,
      };
    // update certType
    case ACTION_TYPES.CERTTYPE_UPDATED_REQUESTED:
      return {
        ...state,
        status: {
          updating: 0,
        },
      };
    case ACTION_TYPES.CERTTYPE_UPDATED_SUCCEED:
      return {
        ...state,
        status: {
          updating: 1,
        },
        certType: {
          ...state.certType,
          name: payload.name,
          content: payload.content,
        },
        certTypes: [
          ...state.certTypes.map(certType => (certType.id === typeId ? payload.data : certType)),
        ],
        meta: payload.meta,
      };
    case ACTION_TYPES.CERTTYPE_UPDATED_FAILED:
      return {
        ...state,
        status: {
          updating: 2,
        },
        error: {
          message: 'Cannot update certType successfully',
        },
      };
    default:
      return state;
  }
}
